<script setup>
import { ref } from 'vue'
import {
  Facebook,
  Instagram,
  Linkedin,
  Video,
  Youtube,
  createLucideIcon,
} from 'lucide-vue-next'
import Logotype from '@/components/Logotype.vue'

const XIcon = createLucideIcon('X', [
  [
    'path',
    {
      d: 'M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z',
      stroke: 'none',
      fill: 'currentColor',
    },
  ],
])

const currentYear = new Date().getFullYear()

const footerLinks = ref([
  { name: 'Blog', href: '/blog' },
  { name: 'Conditions d\'utilisation', href: '/terms' },
  { name: 'Politique de confidentialité', href: '/privacy' },
])

const socialLinks = ref([
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/selfwise.io',
    icon: Linkedin,
  },
  {
    name: 'Twitter',
    href: 'https://x.com/Selfwiseio',
    icon: XIcon, // Twitter,
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/@Selfwiseio',
    icon: Youtube,
  },
  {
    name: 'TikTok',
    href: 'https://www.tiktok.com/@selfwise_io',
    icon: Video,
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/selfwise.io/',
    icon: Instagram,
  },
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61573882709562',
    icon: Facebook,
  },
])
</script>

<template>
  <footer
    class="border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60"
  >
    <div class="container mx-auto px-4 py-12">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <!-- Logo and Copyright -->
        <div class="space-y-4">
          <Logotype />
          <p class="text-sm text-muted-foreground">
            © {{ currentYear }} Selfwise. Tous droits réservés.
          </p>
        </div>

        <!-- Legal Links -->
        <div>
          <h4 class="font-semibold mb-4">
            Lire
          </h4>
          <ul class="space-y-2">
            <li v-for="link in footerLinks" :key="link.name">
              <router-link
                :to="link.href"
                class="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {{ link.name }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Contact -->
        <div>
          <h4 class="font-semibold mb-4">
            Contact
          </h4>
          <a
            href="mailto:support@selfwise.io"
            class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            support@selfwise.io
          </a>
        </div>

        <!-- Social Links -->
        <div>
          <h4 class="font-semibold mb-4">
            Suivez-nous
          </h4>
          <ul class="flex flex-wrap gap-4">
            <li v-for="link in socialLinks" :key="link.name">
              <a
                :href="link.href"
                target="_blank"
                rel="noopener noreferrer"
                class="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2"
                :title="link.name"
              >
                <component :is="link.icon" class="h-5 w-5" />
                <span class="sr-only">{{ link.name }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
